
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import LastSync from '@/components/LastSync.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import moment from 'moment';
import DateFilter from '@/components/reports-v3/components/filters/DateFilter.vue';
import gdbx from '@/store/modules/gdbx';
// tslint:disable:max-line-length
import SelectFilter from '@/components/reports-v3/components/filters/SelectFilter.vue';
import CurrentRatioDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpCurrentRatioDisplayer.vue';
import DebtRatioDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpLiabilitiesRatioDisplayer.vue';
import CashRatioDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpCashBankRatioDisplayer.vue';
import FixedAssetNetWorthRatioDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpFixedAssetsToNetWorthRatioDisplayer.vue';
import CurrentLiabilitiesNetWorthRatioDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpCurrentLiabilitiesToNetWorthRatioDisplayer.vue';
import WorkingCapitalTotalAssetsRatioDisplayer from '@/components/reports-v3/components/codedWidgets/bp/BpWorkingCapitalToTotalAssetsDisplayer.vue';
import FinancialPerformanceTable from '@/components/reports-v3/components/codedWidgets/bp/BpFinancialPerformanceTable.vue';

@Component({
	components: {
		StickyFilterContainer,
		DateFilter,
		LastSync,
		SelectFilter,
		CurrentRatioDisplayer,
		DebtRatioDisplayer,
		CashRatioDisplayer,
		FixedAssetNetWorthRatioDisplayer,
		CurrentLiabilitiesNetWorthRatioDisplayer,
		WorkingCapitalTotalAssetsRatioDisplayer,
		FinancialPerformanceTable,
	},
})
export default class FinancialRatio extends Vue {
	public selectedDay: number = moment().endOf('day').valueOf();

	public mounted() {
		this.track();
	}

	public track() {
		this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
		this.$ga.page(router);
	}

	public get selectedAsOfDate() {
		return this.selectedDateRange[1];
	}

	public get selectedDateRange(): [number, number] {
		const selectedYear = moment(this.selectedDay).year();
		const fyStartMonth = moment(gdbx.accountStartingDateThisYear).month();
		const fyStartDay = moment(gdbx.accountStartingDateThisYear).date();

		// If FY starts on Jan 1, it's the same as calendar year
		if (fyStartMonth === 0 && fyStartDay === 1) {
			return [
				moment(this.selectedDay).startOf('year').valueOf(),
				moment(this.selectedDay).endOf('year').valueOf(),
			];
		}

		// FY 2025 = the financial year ENDING in 2025
		// If FY starts April 1, FY 2025 = April 1, 2024 - March 31, 2025
		const fyStart = moment()
			.year(selectedYear - 1)
			.month(fyStartMonth)
			.date(fyStartDay)
			.startOf('day');

		const fyEnd = moment(fyStart)
			.add(1, 'year')
			.subtract(1, 'day')
			.endOf('day');

		return [fyStart.valueOf(), fyEnd.valueOf()];
	}

	public get selectedAgents() {
		return gdbx.allAgents;
	}

	public onHovering(value: boolean, filterId: string) {
		this.$emit('hovering', value, filterId);
	}
	public onEditing(value: boolean, filterId: string) {
		this.$emit('editing', value, filterId);
	}
}
